import {isNotNilOrEmpty} from 'ramda-adjunct';

import {
  EmailData,
  IdentityCardDataRequestBody,
  IdentityCardRequestBody,
  PhoneNumberData,
} from '@dms/api/customer';
import {PhoneNumber} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {ContactPersonFormValues} from '../ContactPersonForm/ContactPersonForm';

type ContactPersonFormEmail = Omit<EmailData, 'email'> & {
  email: string | Nullish;
};

type ContactPersonFormPhoneNumber = Omit<PhoneNumberData, 'phoneNumber'> & {
  phoneNumber: PhoneNumber | Nullish;
};

type ContactPersonFormIdentityCard = Omit<IdentityCardRequestBody, 'cardData'> & {
  cardData: IdentityCardDataRequestBody | Nullish;
};

type ContactPersonRequestFormValues = Omit<
  ContactPersonFormValues,
  'emails' | 'phoneNumbers' | 'identityCards'
> & {
  emails: ContactPersonFormEmail[];
  phoneNumbers: ContactPersonFormPhoneNumber[];
  identityCards: ContactPersonFormIdentityCard[];
};

const hasEmail = (email: ContactPersonFormEmail): email is EmailData =>
  isNotNilOrEmpty(email.email);

const hasPhoneNumber = (
  phoneNumber: ContactPersonFormPhoneNumber
): phoneNumber is PhoneNumberData => isNotNilOrEmpty(phoneNumber.phoneNumber?.number);

const hasIdentityCard = (
  identityCard: ContactPersonFormIdentityCard
): identityCard is IdentityCardRequestBody => isNotNilOrEmpty(identityCard.cardData?.cardNumber);

export const getContactPersonRequestBody = (values: ContactPersonRequestFormValues) => ({
  personData: values.personData,
  phoneNumbers: values.phoneNumbers.filter(hasPhoneNumber),
  emails: values.emails.filter(hasEmail),
  identityCards: values.identityCards.filter(hasIdentityCard),
  permanentAddressId: values.permanentAddressId,
});
